/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D text
 */

import React from "react";
import PropTypes from "prop-types";

function Text({
    width,
    color,
    text,
    size,
    sizeDecimal,
    children,
    crop = false,
    reverseCrop,
    cropLines,
    secondary,
    font,
    ...otherAttributes
}) {
    const sizes = {
        h1: 2,
        h2: 3,
        "h2.5": 3.5,
        h3: 4,
        h4: 5,
        h5: 6,
        h6: 8,
        p1: 10,
        p2: 12,
        p3: 14,
        p4: 16,
        p5: 18,
        p6: 20,
        p7: 22
    };
    const wrapCount = width * (sizeDecimal || sizes[size]);
    if (crop && text && text.length * 0.9 > wrapCount) {
        text = reverseCrop
            ? text.slice(-wrapCount)
            : text.slice(
                  0,
                  wrapCount * Math.floor(cropLines / ((width / wrapCount) * 2))
              );
    }

    return (
        <a-text
            value={text || " "}
            width={width}
            color={color || (secondary ? "#c6c6c6" : "#f2f2f2")}
            wrap-count={wrapCount}
            font={font || AFRAME.customFont}
            negate={AFRAME.customFont ? "false" : "true"}
            {...otherAttributes}
        >
            {children}
        </a-text>
    );
}

Text.propTypes = {
    width: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
};

export default Text;
